var BillingAddressModel = (function (CheckoutApiModel) {
	return CheckoutApiModel.extend({
		idAttribute: 'ID',

		//isActive: function () {
		//	return this._isActive;
		//},

		//setActive: function (isActive) {
		//	this._isActive = isActive;
		//},

		isValid: function () {
			return Boolean(this.get('ID'));
		},

		setData: function (data) {
			this.set(data);
		}
	});
})(CheckoutApiModel);
